module.exports = __webpack_public_path__ + "static/media/RivieraMaya.8e67b1e3.jpg";